import { SSO_ATTRIBUTE_PLACEHOLDER_REGEX, extractAttributeKeys } from '../attributes/helpers'

export const formMappingRule = (params, groupId, tenants, roles) => {
  const usernameAttributeMappingTemplate = params.usernameAttributeMappingTemplate
  const emailAttributeMappingTemplate = params.emailAttributeMappingTemplate
  const usernameAttributeKeys = extractAttributeKeys(usernameAttributeMappingTemplate)
  const emailAttributeKeys = extractAttributeKeys(emailAttributeMappingTemplate)

  // Build local templates preserving separators and replacing placeholders with index positions
  const buildIndexedTemplate = (template: string, startIndex: number = 0) => {
    let idx = startIndex
    return template.replace(SSO_ATTRIBUTE_PLACEHOLDER_REGEX, () => {
      const value = `{${idx}}`
      idx += 1
      return value
    })
  }

  const usernameLocal = buildIndexedTemplate(usernameAttributeMappingTemplate)
  const localUsernameTemplate = usernameLocal
  const numUsernameAttributes = usernameAttributeKeys.length
  const emailLocal = buildIndexedTemplate(emailAttributeMappingTemplate, numUsernameAttributes)
  const localEmailTemplate = emailLocal

  const usernameAndEmailAttributes = [
    ...usernameAttributeKeys.map((key) => ({
      type: key,
    })),
    ...emailAttributeKeys.map((key) => ({
      type: key,
    })),
  ]

  const customAttributes = params.customMappings.map((mapping) => {
    return {
      type: mapping.attribute,
      [mapping.criteria]: mapping.values.split(',').map((v) => v.trim()),
      regex: !!mapping.regexMatching,
    }
  })

  // const projects =
  //   Object.keys(params?.roleAssignments)?.map((tenantId: string) => {
  //     return {
  //       name: tenants?.find((tenant) => tenant.id === tenantId)?.name,
  //       roles: [
  //         {
  //           name: roles?.find((role) => role.id === params?.roleAssignments?.[tenantId])?.name,
  //         },
  //       ],
  //     }
  //   }) ?? []

  const newRule = {
    local: [
      {
        user: {
          name: localUsernameTemplate,
          email: localEmailTemplate,
        },
        group: {
          id: groupId,
        },
        // projects,
      },
    ],
    remote: [...usernameAndEmailAttributes, ...customAttributes],
  }
  return newRule
}
